import * as React from "react";
function SvgListClose(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={4}
        stroke="currentColor"
        d="M0 1.95L32 2M10 11h22M10 21h22M0 30h32"
      />
      <path d="M7 9v14l-7-7 7-7z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgListClose);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
